import { Component, Input, OnInit } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-logout-all-confirm',
    templateUrl: './logout-all-confirm.component.html',
    imports: [
        CommonModule
    ]
})
export class LogoutAllConfirmComponent implements OnInit {

    constructor() { }

    ngOnInit() {

    }

    @Input() public logOut: () => void;
    @Input() public remainSignedIn: () => void;

    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        
    }
}
